<template>
  <b-row>
    <b-col cols="12">
      <b-row >
        <b-col cols="12">
          <div class="flex h-full" style="cursor: pointer;">


            <div
              :class="[
                currentRoute === 'nir' ? 'menu-item-active' : 'menu-item'
              ]"
              @click="select('nir')"
            >
              <div class="flex mt-6">
                <div style="font-size: 14px">Non Individuals</div>
                <b-badge class="bg-blue mx-1 mb-1">{{ totalNumber.toLocaleString() }}</b-badge>
              </div>
            </div>


          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <NIRRegistry v-if="currentRoute === 'nir'" @loaded="onNirLoaded" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

import { mapActions, mapGetters } from "vuex";

import NIRRegistry from "./NIRRegistry.vue";


export default {
  name: "NirRegistryBreakdown",
  components: {
    NIRRegistry
  },
  data() {
    return {
      currentRoute: "nir",
      search: "",
      currentPage: 1,
      limit: 15,
      totalNumber: 0
    };
  },
  mounted() {
    localStorage.removeItem("registryEntity");
    this.fetch();
  },
  methods: {
    ...mapActions([
    ]),
    onNirLoaded(total) {
      this.totalNumber = total;
    },
    fetch() {
      // let data = {
      //   q: this.search,
      //   page: this.currentPage,
      //   limit: this.limit,
      //   offset: this.limit
      // };

    },
    select(route) {
      this.currentRoute = route;
    }
  },
  computed: {
    ...mapGetters([

    ])
  }
};
</script>

<style scoped></style>